<template>
  <!-- 定制化服务 -->
  <div>
    <!-- [综合性公司服务 – 定制化] / [基金托管服务 – 定制化] -->
    <el-form ref="dataForm" :model="dataForm" :rules="dataRule" label-width="126px">
      <el-form-item :label="$t('creation.operatingType')" prop="operationType" ref="operationType" v-if="isCoordinator">
        <el-radio-group v-model="dataForm.operationType" @change="operationTypeChange">
          <el-radio :label="1">{{ $t("creation.renewService") }}</el-radio>
          <el-radio :label="2">{{ $t("creation.increaseService") }}</el-radio>
          <el-radio :label="3">{{ $t("creation.other") }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 拷贝自 -->
      <el-form-item
        :label="$t('creation.copySource')"
        prop="copyFromId"
        ref="copyFromId"
        :rules="[
          {
            required: dataForm.operationType == 1 || dataForm.operationType == 2 ? true : false,
            message: $t('common.placeholder.select'),
            trigger: 'submit',
          },
        ]"
      >
        <el-select v-model="dataForm.copyFromId" :placeholder="$t('common.placeholder.select')" filterable clearable class="wd500">
          <el-option
            v-for="item of copyFromOpions"
            :key="item.applymentId"
            :label="
              item.companyName
                ? `[${item.applymentNo}] ${item.companyName}`
                : item.proposedCompanyName
                ? `[${item.applymentNo}] ${item.proposedCompanyName}`
                : `[${item.applymentNo}] ${item.proposedCompanyName1} / ${item.proposedCompanyName2} / ${item.proposedCompanyName3}`
            "
            :value="item.applymentId"
          >
            <span v-if="item.companyName">[{{ item.applymentNo }}] {{ item.companyName }}</span>
            <span v-else-if="item.proposedCompanyName">[{{ item.applymentNo }}] {{ item.proposedCompanyName }}</span>
            <p v-else>
              <span>[{{ item.applymentNo }}]</span>
              <span>{{ item.proposedCompanyName1 }} /</span>
              <span>{{ item.proposedCompanyName2 }} /</span>
              <span>{{ item.proposedCompanyName3 }}</span>
            </p>
          </el-option>
        </el-select>
        <p class="pt6 fs12 lh16 crgy919">
          {{ $t("creation.copySourceExplain") }}
        </p>
      </el-form-item>
      <!-- 促销编号 -->
      <el-form-item :label="$t('creation.promotion')">
        <el-input v-model="dataForm.promotionCode" :placeholder="$t('common.placeholder.enter')" class="wd500" v-regexFilter="$halfWidthRegex"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getAction } from "@/api/common";
import { validateLocation } from "@/utils/common";
import { mapState } from "vuex";
export default {
  props: {
    businessGenre: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dataForm: {
        operationType: null,
        copyFromId: null,
        promotionCode: "",
      },
      dataRule: {
        operationType: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
      },
      allCopyFromList: [], // 全部公司列表
      copyFromOpions: [], // 根据操作类型筛选后的公司列表
    };
  },
  computed: {
    ...mapState("user", ["isCoordinator"]),
  },
  methods: {
    // 初始化
    init() {
      this.$refs["dataForm"]?.resetFields();
      this.getCompletedCompanyList();
    },
    // 获取已完成创建公司列表
    getCompletedCompanyList() {
      getAction("/companyApplyment/getCompanyList", {
        businessGenre: this.businessGenre,
      })
        .then(res => {
          const resData = res.data || [];
          // 是否为后台业务人员
          if (this.isCoordinator) {
            this.allCopyFromList = resData;
            this.$set(this.dataForm, "operationType", 1);
            this.operationTypeChange();
          } else {
            this.copyFromOpions = resData;
            this.$set(this.dataForm, "operationType", null);
          }
        })
        .catch(err => {});
    },
    // 操作类型 - change
    operationTypeChange() {
      this.$set(this.dataForm, "copyFromId", null);
      const allCopyFromListCopy = this.allCopyFromList;
      const operationType = this.dataForm.operationType;
      if (operationType == 1) {
        this.copyFromOpions = allCopyFromListCopy.filter(item => item.applymentStatus == "FINISH" && !item.hasRenew);
      } else if (operationType == 2) {
        this.copyFromOpions = allCopyFromListCopy.filter(item => item.applymentStatus == "FINISH");
      } else {
        this.copyFromOpions = allCopyFromListCopy.filter(item => item.byMyself);
        this.$nextTick(() => {
          this.$refs["dataForm"].clearValidate({ props: "copyFromId" });
        });
      }
    },
    // 提交表单(由父级触发)
    dataFormSubmit() {
      return new Promise((resolve, reject) => {
        this.$refs["dataForm"].validate((valid, object) => {
          if (valid) {
            const params = {
              ...this.dataForm,
            };
            // 是否为后台业务人员
            if (this.isCoordinator) {
              const isRenew = params.operationType == 1 ? true : false;
              const isLaterService = params.operationType == 2 ? true : false;
              params.isRenew = isRenew;
              params.isLaterService = isLaterService;
            }
            resolve({
              ...params,
            });
          } else {
            validateLocation(object, this);
            reject();
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
